<template>
    <div class="modal fade" id="costumModalresume" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Daftar
                        </span>
                        <span v-else>
                            List
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="row">
                        <div class="col-sm-12" data-wow-delay="0.1s">
                            <input type="text" v-model="carikata" class="form-control form-control-sm"
                                placeholder="Enter Search Keywords / Masukkan Kata Kunci Pencarian">
                            <div class="col-sm-12" data-wow-delay="0.1s">
                                &nbsp;
                            </div>
                            <div class="table-responsive table-wrapper">
                                <table class="table m-0" id="tabeldata" style="font-size: small;">
                                    <thead>
                                        <tr>
                                            <th style="width: 50px;">No</th>
                                            <th style="width: 50px;">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Tanggal</span>
                                                <span v-else>Date</span>
                                            </th>
                                            <th style="width: 100px;">Status</th>
                                            <th style="width: 100px;">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Nama</span>
                                                <span v-else>Name</span>
                                            </th>
                                            <th style="width: 100px;">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Alamat Email</span>
                                                <span v-else>Email address</span>
                                            </th>
                                            <th style="width: 100px;">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Kategori</span>
                                                <span v-else>Category</span>
                                            </th>
                                            <th style="width: 300px;">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Aduan</span>
                                                <span v-else>Complaint</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <template v-for="(datalist, urutlist) in filteredKataData" :key="urutlist">
                                        <tbody>
                                            <tr>
                                                <td class="text-center">{{ urutlist + 1 }}</td>
                                                <td class="text-center">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_formatDate(datalist.createddate) }}</span>
                                                    <span v-else>{{ G_formatDateEng(datalist.createddate) }}</span>
                                                </td>
                                                <td class="text-justify">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        datalist.statusaduan }}</span>
                                                    <span v-else>{{ datalist.statusaduan_eng }}</span>
                                                </td>
                                                <td class="text-justify">{{ datalist.nama }}</td>
                                                <td class="text-justify">{{ datalist.alamat }}</td>
                                                <td class="text-justify">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        datalist.jenis
                                                        }}</span>
                                                    <span v-else>{{ datalist.jenis_eng }}</span>
                                                </td>
                                                <td class="text-justify"><span v-html="datalist.aduan"></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                    <tbody v-if="(datapesan == 'data kosong')">
                                        <tr>
                                            Data masih kosong
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                            data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalresume()">
                            <b>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tutup
                                </span>
                                <span v-else>
                                    Close
                                </span>
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb" style="height: 350px !important;">
        <div class="container text-center" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">MONITORING ADUAN</span>
                <span v-else>MONITORING COMPLAINTS</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-warning">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Monitoring Aduan</span>
                    <span v-else>Monitoring Complaint</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">
        <div class="col-sm-12 wow fadeInDown">
            <div class="card cardputih collapsed-card">
                <div class="card-header border-transparent" data-card-widget="collapse" style="cursor: pointer;">
                    <label>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Data</span>
                        <span v-else>Data Filters</span>
                    </label>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body px-3">
                    <div class="row">
                        <div class="col-sm-3 text-center">
                            <label>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Lokasi</span>
                                <span v-else>Location</span>
                            </label>
                            <v-select :options="lokasi" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedlokasi" @update:modelValue="onlokasiChange"
                                style="background-color: #ffffff;color: black;"></v-select>
                        </div>
                        <div class="col-sm-3 text-center">
                            <label>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Tahun Aduan</span>
                                <span v-else>Complaint Year</span>
                            </label>
                            <v-select :options="tahunmulai" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedtahunmulai" @update:modelValue="ontahunmulaiChange"
                                style="background-color: #ffffff;color: black;"></v-select>
                        </div>
                        <div class="col-sm-3 text-center">
                            <label>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Tahun Selesai</span>
                                <span v-else>Year Completed</span>
                            </label>
                            <v-select :options="tahunselesai" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedtahunselesai" @update:modelValue="ontahunselesaiChange"
                                style="background-color: #ffffff;color: black;"></v-select>
                        </div>
                        <div class="col-sm-3 text-center">
                            <label>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Media</span>
                                <span v-else>Media</span>
                            </label>
                            <v-select :options="media" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedmedia" @update:modelValue="onmediaChange"
                                style="background-color: #ffffff;color: black;"></v-select>
                        </div>
                        <div class="col-sm-3 text-center">
                            <label>Status</label>
                            <v-select :options="status" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedstatus" @update:modelValue="onstatusChange"
                                style="background-color: #ffffff;color: black;"></v-select>
                        </div>
                        <div class="col-sm-9 text-center">
                            <label>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Kategori</span>
                                <span v-else>Category</span>
                            </label>
                            <v-select :options="kategori" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedkategori" @update:modelValue="onkategoriChange"
                                style="background-color: #ffffff;color: black;"></v-select>
                        </div>
                        <div class="col-sm-12">&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">
        <div class="col-sm-12">
            <div class="section-title mb-5"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        INFOGRAFIS ADUAN
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        COMPLAINT INFOGRAPHIC
                    </h1>
                </div>
            </div>
            <div class="card cardputih">
                <div class="card-header border-transparent" data-card-widget="collapse" style="cursor: pointer;">
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body px-3">
                    <div class="row g-4 justify-content-center">
                        <div class="col-sm-6"
                            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                            <Bar1ChartMonitoringProyek type="bar" :options="chartOptionsbar1" :series="seriesbar1"
                                height="400">
                            </Bar1ChartMonitoringProyek>
                        </div>
                        <div class="col-sm-6"
                            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                            <Pie1ChartMonitoringProyek type="pie" :options="chartOptionspie1" :series="seriespie1"
                                height="400">
                            </Pie1ChartMonitoringProyek>
                        </div>
                        <div class="col-sm-6"
                            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                            <BartahunChartMonitoringProyek type="bar" :options="chartOptionsbartahun"
                                :series="seriesbartahun" height="400">
                            </BartahunChartMonitoringProyek>
                        </div>
                        <div class="col-sm-6"
                            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                            <BarkategoriChartMonitoringProyek type="bar" :options="chartOptionsbarjenis"
                                :series="seriesbarjenis" height="400">
                            </BarkategoriChartMonitoringProyek>
                        </div>
                        <div class="col-sm-6"
                            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                            <PiekategoriChartMonitoringProyek type="pie" :options="chartOptionspiekategori"
                                :series="seriespiekategori" height="400">
                            </PiekategoriChartMonitoringProyek>
                        </div>
                        <div class="col-sm-6"
                            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                            <BarmediaChartMonitoringProyek type="bar" :options="chartOptionsbarmedia"
                                :series="seriesbarmedia" height="400">
                            </BarmediaChartMonitoringProyek>
                        </div>
                        <div class="col-sm-6"
                            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                            <PiemediaChartMonitoringProyek type="pie" :options="chartOptionspiemedia"
                                :series="seriespiemedia" height="400">
                            </PiemediaChartMonitoringProyek>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">
        <div class="container-fluid py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        REPORT PENGELOLAAN INFORMASI DAN PENGADUAN
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        INFORMATION MANAGEMENT AND COMPLAINTS REPORT
                    </h1>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="col-sm-12 text-center">
                    <a class="hitam">
                        <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                            data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel1('_PIP_')">
                            <i class="fas fa-download"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Unduh Data .xlsx
                            </span>
                            <span v-else>
                                Download Data .xlsx
                            </span>
                        </button>
                    </a>
                </div>
                <div class="col-sm-12">&nbsp;</div>
            </div>
            <div class="col-sm-12 wow fadeInDown">
                <div class="card cardputih collapsed-card">
                    <div class="card-header border-transparent" data-card-widget="collapse" style="cursor: pointer;">
                        <label>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Kolom</span>
                            <span v-else>Column Filter</span>
                        </label>
                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body px-3">
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxTanggal" value="optionTanggal" checked
                                        @click="showColumnTanggal = !showColumnTanggal">
                                    <label for="customCheckboxTanggal" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Tanggal Aduan
                                        </span>
                                        <span v-else>
                                            Complaint Date
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxSaluran" value="optionSaluran" checked
                                        @click="showColumnSaluran = !showColumnSaluran">
                                    <label for="customCheckboxSaluran" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Saluran Aduan
                                        </span>
                                        <span v-else>
                                            Complaint Channel
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxLokasi" value="optionLokasi" checked
                                        @click="showColumnLokasi = !showColumnLokasi">
                                    <label for="customCheckboxLokasi" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Lokasi
                                        </span>
                                        <span v-else>
                                            Location
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxKeluhan" value="optionKeluhan" checked
                                        @click="showColumnKeluhan = !showColumnKeluhan">
                                    <label for="customCheckboxKeluhan" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Keluhan
                                        </span>
                                        <span v-else>
                                            Complaint
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxKategori" value="optionKategori" checked
                                        @click="showColumnKategori = !showColumnKategori">
                                    <label for="customCheckboxKategori" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Kategori
                                        </span>
                                        <span v-else>
                                            Category
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxStatus" value="optionStatus" checked
                                        @click="showColumnStatus = !showColumnStatus">
                                    <label for="customCheckboxStatus" class="custom-control-label">
                                        Status</label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxSelesai" value="optionSelesai" checked
                                        @click="showColumnSelesai = !showColumnSelesai">
                                    <label for="customCheckboxSelesai" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Tanggal Selesai
                                        </span>
                                        <span v-else>
                                            Completion Date
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxLama" value="optionLama" checked
                                        @click="showColumnLama = !showColumnLama">
                                    <label for="customCheckboxLama" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Lama Penyelesaian
                                        </span>
                                        <span v-else>
                                            Completion Time
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div class="table-responsive table-wrapper">
                    <table class="table m-0" id="tabeldata1" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;">No</th>
                                <th style="width: 50px;" v-if="showColumnTanggal">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tanggal Aduan
                                    </span>
                                    <span v-else>Complaint Date</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnSaluran">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Pengaduan Disampaikan Melalui
                                    </span>
                                    <span v-else>Complaints Submitted Via</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnLokasi">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Lokasi Terkait Aduan
                                    </span>
                                    <span v-else>Locations Regarding Complaints</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnKeluhan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Keluhan yang Disampaikan
                                    </span>
                                    <span v-else>Complaints Submitted</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnKategori">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Kategori Aduan
                                    </span>
                                    <span v-else>Complaint Category</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnStatus">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Status Penanganan
                                    </span>
                                    <span v-else>Handling Status</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnSelesai">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tanggal Selesai
                                    </span>
                                    <span v-else>Completion Date</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnLama">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Lama Penyelesaian (Hari)
                                    </span>
                                    <span v-else>Completion Time (Days)</span>
                                </th>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in dataaduan1" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td class="text-center">{{ urutlist + 1 }}</td>
                                    <td class="text-center" v-if="showColumnTanggal">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ G_formatDateNonWIB(datalist.tanggal) }}
                                        </span>
                                        <span v-else>
                                            {{ G_formatDateNonWIBEng(datalist.tanggal) }}
                                        </span>
                                    </td>
                                    <td class="text-justify" v-if="showColumnSaluran">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.asaladuan }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.asaladuan_eng }}
                                        </span>
                                    </td>
                                    <td class="text-justify" v-if="showColumnLokasi">{{ datalist.namakota }}</td>
                                    <td class="text-justify" v-if="showColumnKeluhan"><span
                                            v-html="datalist.aduan"></span></td>
                                    <td class="text-justify" v-if="showColumnKategori">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.jenis }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.jenis_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" v-if="showColumnStatus">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.namaproses }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.namaproses_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" v-if="showColumnSelesai">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ G_formatDateNonWIB(datalist.tanggalselesai) }}
                                        </span>
                                        <span v-else>
                                            {{ G_formatDateNonWIBEng(datalist.tanggalselesai) }}
                                        </span>
                                    </td>
                                    <td class="text-center" data-z="#,##0" v-if="showColumnLama">{{ datalist.lamahari }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                        <tbody v-if="(datapesan == 'data kosong')">
                            <tr>
                                Data masih kosong
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-sm-12">&nbsp;</div>

            <div class="col-sm-12">
                <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                    style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                    <div class="sub-style">
                        <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                            REKAPITULASI DATA PENGELOLAAN INFORMASI DAN PENGADUAN
                        </h1>
                        <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                            SUMMARY OF INFORMATION MANAGEMENT AND COMPLAINT DATA
                        </h1>
                    </div>
                </div>
                <div class="col-sm-12 text-center">
                    <a class="hitam">
                        <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                            data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel2('_ResumePIP_')">
                            <i class="fas fa-download"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Unduh Data .xlsx
                            </span>
                            <span v-else>
                                Download Data .xlsx
                            </span>
                        </button>
                    </a>
                </div>
                <div class="col-sm-12">&nbsp;</div>
            </div>
            <div class="col-sm-12 wow fadeInDown">
                <div class="card cardputih collapsed-card">
                    <div class="card-header border-transparent" data-card-widget="collapse" style="cursor: pointer;">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Kolom</span>
                        <span v-else>Column Filter</span>
                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body px-3">
                        <div class="row">
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxLokasi2" value="optionLokasi2" checked
                                        @click="showColumnLokasi2 = !showColumnLokasi2">
                                    <label for="customCheckboxLokasi2" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Lokasi
                                        </span>
                                        <span v-else>
                                            Location
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxTotal" value="optionTotal" checked
                                        @click="showColumnTotal = !showColumnTotal">
                                    <label for="customCheckboxTotal" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Total Aduan
                                        </span>
                                        <span v-else>
                                            Total Complaints
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxMedia2" value="optionMedia2" checked
                                        @click="showColumnMedia2 = !showColumnMedia2">
                                    <label for="customCheckboxMedia2" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Media Aduan
                                        </span>
                                        <span v-else>
                                            Complaint Media
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxKategori2" value="optionKategori2" checked
                                        @click="showColumnKategori2 = !showColumnKategori2">
                                    <label for="customCheckboxKategori2" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Kategori Aduan
                                        </span>
                                        <span v-else>
                                            Complaint Category
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                        id="customCheckboxStatus2" value="optionStatus2" checked
                                        @click="showColumnStatus2 = !showColumnStatus2">
                                    <label for="customCheckboxStatus2" class="custom-control-label">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Status Aduan
                                        </span>
                                        <span v-else>
                                            Complaint Status
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div class="table-responsive table-wrapper">
                    <table class="table m-0" id="tabeldata2" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;" rowspan="2">No</th>
                                <th style="width: 50px;" rowspan="2" v-if="showColumnLokasi2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Lokasi Terkait Aduan (Kota)
                                    </span>
                                    <span v-else>
                                        Location Regarding Complaints (City)
                                    </span>
                                </th>
                                <th style="width: 50px;" rowspan="2" v-if="showColumnTotal">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Total Pengaduan Teregistrasi
                                    </span>
                                    <span v-else>
                                        Total Registered Complaints
                                    </span>
                                </th>
                                <th :colspan="colspanmedia" v-if="showColumnMedia2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Pengaduan Berdasarkan Pengaduan Disampaikan Melalui
                                    </span>
                                    <span v-else>
                                        Number of Complaints Based on Complaints Submitted Through
                                    </span>
                                </th>
                                <th :colspan="colspanjenis" v-if="showColumnKategori2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Pengaduan Berdasarkan Kategori Aduan
                                    </span>
                                    <span v-else>
                                        Number of Complaints Based on Complaint Category
                                    </span>
                                </th>
                                <th colspan="2" v-if="showColumnStatus2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Pengaduan Berdasarkan Status Penanganan
                                    </span>
                                    <span v-else>
                                        Number of Complaints Based on Handling Status
                                    </span>
                                </th>
                            </tr>
                            <tr>
                                <th style="width: 50px;" v-for="(datalistmedia, urutlistmedia) in datamedia2"
                                    :key="urutlistmedia" v-if="showColumnMedia2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        {{ datalistmedia.nama }}
                                    </span>
                                    <span v-else>
                                        {{ datalistmedia.nama_eng }}
                                    </span>
                                </th>
                                <th style="width: 50px;" v-for="(datalistjenis, urutlistjenis) in datakategori2"
                                    :key="urutlistjenis" v-if="showColumnKategori2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        {{ datalistjenis.kategoriMasalahNm }}
                                    </span>
                                    <span v-else>
                                        {{ datalistjenis.kategoriMasalahNm_eng }}
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnStatus2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum Selesai
                                    </span>
                                    <span v-else>
                                        Not finished yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnStatus2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in dataaduan2" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td class="text-center">{{ urutlist + 1 }}</td>
                                    <td class="text-center" v-if="showColumnLokasi2">{{ datalist.nama }}</td>
                                    <td class="text-center" data-z="#,##0" v-if="showColumnTotal">{{
                                        datalist.jumlahaduan }}</td>
                                    <td class="text-center" data-z="#,##0"
                                        v-for="(datalistmedia, urutlistmedia) in datalist.media" :key="urutlistmedia"
                                        v-if="showColumnMedia2">
                                        {{ datalistmedia.jumlahaduan }}
                                    </td>
                                    <td class="text-center" data-z="#,##0"
                                        v-for="(datalistjenis, urutlistjenis) in datalist.jenis" :key="urutlistjenis"
                                        v-if="showColumnKategori2">
                                        {{ datalistjenis.jumlahaduan }}
                                    </td>
                                    <td class="text-center" data-z="#,##0" v-if="showColumnStatus2">{{
                                        datalist.jumlahaduanbelumselesai }}</td>
                                    <td class="text-center" data-z="#,##0" v-if="showColumnStatus2">{{
                                        datalist.jumlahaduanselesai }}</td>
                                </tr>
                            </tbody>
                        </template>
                        <tbody v-if="(datapesan == 'data kosong')">
                            <tr>
                                Data masih kosong
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">
        <div class="container-fluid py-2">
            <div class="col-sm-12">&nbsp;</div>
            <div class="col-sm-12">
                <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                    style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                    <div class="sub-style">
                        <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                            REKAPITULASI PROSES PENGELOLAAN INFORMASI DAN PENGADUAN
                        </h1>
                        <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                            SUMMARY OF INFORMATION MANAGEMENT AND COMPLAINT PROCESS
                        </h1>
                    </div>
                </div>
                <div class="col-sm-12 text-center">
                    <a class="hitam">
                        <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                            data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel3('_ResumeProsesPIP_')">
                            <i class="fas fa-download"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Unduh Data .xlsx
                            </span>
                            <span v-else>
                                Download Data .xlsx
                            </span>
                        </button>
                    </a>
                </div>
                <div class="col-sm-12">&nbsp;</div>
            </div>
            <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div class="table-responsive table-wrapper">
                    <table class="table m-0" id="tabeldata" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;" rowspan="2">No</th>
                                <th style="width: 120px;" rowspan="2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Kategori Aduan
                                    </span>
                                    <span v-else>
                                        Complaint Category
                                    </span>
                                </th>
                                <th v-for="(listtahun, uruttahun) in datatahun" :colspan="colspan">{{ listtahun }}</th>
                            </tr>
                            <tr>
                                <template v-for="(listtahun, uruttahun) in datatahun">
                                    <th>Total</th>
                                    <th v-for="(listproses, urutproses) in dataproses"
                                        v-if="(bahasa === null) || (bahasa == 'ina')">
                                        {{ listproses }}
                                    </th>
                                    <th v-for="(listproses, urutproses) in dataproses_eng" v-else>
                                        {{ listproses }}
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td class="text-center">{{ urutlist + 1 }}</td>
                                    <td>
                                        <a href="javascript:void(0)" @click="aduanAct(datalist.id)">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                {{ datalist.nama }}
                                            </span>
                                            <span v-else>
                                                {{ datalist.nama_eng }}
                                            </span>
                                        </a>
                                    </td>
                                    <template v-for="(listawp, urutawp) in datalist.detail" :key="urutawp">
                                        <td class="text-center">{{ listawp.jumlah }}</td>
                                        <td class="text-center">{{ listawp.diterima }}</td>
                                        <td class="text-center">{{ listawp.diproses }}</td>
                                        <td class="text-center">{{ listawp.ditindaklanjuti }}</td>
                                        <td class="text-center">{{ listawp.selesai }}</td>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                        <tbody v-if="(datapesan == 'data kosong')">
                            <tr>
                                Data masih kosong
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import vSelect from 'vue-select';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, vSelect, Bar1ChartMonitoringProyek: VueApexCharts
        , Pie1ChartMonitoringProyek: VueApexCharts, BartahunChartMonitoringProyek: VueApexCharts
        , BarkategoriChartMonitoringProyek: VueApexCharts, PiekategoriChartMonitoringProyek: VueApexCharts
        , BarmediaChartMonitoringProyek: VueApexCharts, PiemediaChartMonitoringProyek: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            carikata: '',
            colspan: 0,
            datatahun: [],
            dataproses: [],
            dataproses_eng: [],
            showColumnRegister: true,
            showColumnTanggal: true,
            showColumnSaluran: true,
            showColumnLokasi: true,
            showColumnKeluhan: true,
            showColumnKategori: true,
            showColumnStatus: true,
            showColumnSelesai: true,
            showColumnLama: true,
            showColumnLokasi2: true,
            showColumnTotal: true,
            showColumnMedia2: true,
            showColumnKategori2: true,
            showColumnStatus2: true,
            project_id: process.env.VUE_APP_PROJECT_ID,
            master: [],
            dataaduan1: [],
            dataaduan2: [],
            colspanmedia: 0,
            colspanjenis: 0,
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedlokasi: '',
            tahunmulai: [],
            datatahunmulai: [],
            defaultSelectedtahunmulai: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahunmulai: '',
            tahunselesai: [],
            datatahunselesai: [],
            defaultSelectedtahunselesai: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahunselesai: '',

            kategori: [],
            datakategori: [],
            defaultSelectedkategori: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedkategori: '',

            media: [],
            datamedia: [],
            defaultSelectedmedia: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedmedia: '',

            kategori2: [],
            datakategori2: [],
            defaultSelectedkategori2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedkategori2: '',

            media2: [],
            datamedia2: [],
            defaultSelectedmedia2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedmedia2: '',

            status: [],
            datastatus: [],
            defaultSelectedstatus: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedstatus: '',

            seriesbar1: [],
            chartOptionsbar1: {
                title: {
                    text: 'Jumlah Total Aduan Per Lokasi',
                    align: 'center'
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'Lokasi'
                    }
                },
                yaxis: {
                    title: {
                        text: 'Jumlah Aduan'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Data"
                        }
                    }
                }
            },

            seriesbartahun: [],
            chartOptionsbartahun: {
                title: {
                    text: 'Jumlah Total Aduan Per Tahun',
                    align: 'center'
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'Tahun'
                    }
                },
                yaxis: {
                    title: {
                        text: 'Jumlah Aduan'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Data"
                        }
                    }
                }
            },

            seriesbarjenis: [],
            chartOptionsbarjenis: {
                title: {
                    text: 'Jumlah Total Aduan Per Kategori',
                    align: 'center'
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'Kategori'
                    }
                },
                yaxis: {
                    title: {
                        text: 'Jumlah Aduan'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Data"
                        }
                    }
                }
            },

            seriesbarmedia: [],
            chartOptionsbarmedia: {
                title: {
                    text: 'Jumlah Total Aduan Per Saluran Pengaduan',
                    align: 'center'
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'Saluran Aduan'
                    }
                },
                yaxis: {
                    title: {
                        text: 'Jumlah Aduan'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Data"
                        }
                    }
                }
            },

            seriespie1: [],
            chartOptionspie1: {
                title: {
                    text: 'Jumlah Total Aduan',
                    align: 'center'
                },
                chart: {
                    width: 380,
                    type: 'pie',
                    toolbar: {
                        show: true
                    }
                },
                colors: ['#1E90FF', '#00FA9A', '#2E8B57', '#F44336', '#FFD700', '#FF6347', '#E91E63', '#9C27B0', '#FF00FF', '#FF69B4'],
                legend: {
                    show: true,
                    position: 'bottom',
                },
                labels: ['Selesai', 'Belum Selesai'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            seriespiekategori: [],
            chartOptionspiekategori: {
                title: {
                    text: 'Jumlah Kategori Aduan',
                    align: 'center'
                },
                chart: {
                    width: 380,
                    type: 'pie',
                    toolbar: {
                        show: true
                    }
                },
                colors: ['#1E90FF', '#00FA9A', '#2E8B57', '#F44336', '#FFD700', '#FF6347', '#E91E63', '#9C27B0', '#FF00FF', '#FF69B4'],
                legend: {
                    show: true,
                    position: 'bottom',
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            seriespiemedia: [],
            chartOptionspiemedia: {
                title: {
                    text: 'Jumlah Saluran Pengaduan',
                    align: 'center'
                },
                chart: {
                    width: 380,
                    type: 'pie',
                    toolbar: {
                        show: true
                    }
                },
                colors: ['#1E90FF', '#00FA9A', '#2E8B57', '#F44336', '#FFD700', '#FF6347', '#E91E63', '#9C27B0', '#FF00FF', '#FF69B4'],
                legend: {
                    show: true,
                    position: 'bottom',
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
        };
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.master
                : this.master.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        tutupmodalresume() {
            $('#costumModalresume').modal('hide');
        },
        async G_tableCSVTabel1(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakaduan-Data?random=" + random + "&project_id=" + this.project_id + "&lokasi=" + this.selectedlokasi + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&media=" + this.selectedmedia + "&status=" + this.selectedstatus + "&kategori=" + this.selectedkategori).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel2(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakaduan-Resume?random=" + random + "&project_id=" + this.project_id + "&lokasi=" + this.selectedlokasi + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&media=" + this.selectedmedia + "&status=" + this.selectedstatus + "&kategori=" + this.selectedkategori).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel3(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakaduan-Proses?random=" + random + "&project_id=" + this.project_id + "&lokasi=" + this.selectedlokasi + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&media=" + this.selectedmedia + "&status=" + this.selectedstatus + "&kategori=" + this.selectedkategori).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        ontahunmulaiChange(a) {
            try {
                this.selectedtahunmulai = this.tahunmulai[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        ontahunselesaiChange(a) {
            try {
                this.selectedtahunselesai = this.tahunselesai[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onkategoriChange(a) {
            try {
                this.selectedkategori = this.kategori[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onmediaChange(a) {
            try {
                this.selectedmedia = this.media[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onstatusChange(a) {
            try {
                this.selectedstatus = this.status[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedlokasi);
            this.ambildata();
        },
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });


                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedlokasi = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.lokasi.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedlokasi = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.lokasi.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationreffmonitoring-TahunProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datatahunmulai = [];
                        this.tahunmulai = [];
                        this.datatahunmulai = Response.data.content.data;
                        this.datatahunmulai.forEach((item) => {
                            this.tahunmulai.push({
                                label: item.tahun,
                                code: this.datatahunmulai.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });


                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedtahunmulai = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.tahunmulai.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedtahunmulai = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.tahunmulai.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                        this.datatahunselesai = [];
                        this.tahunselesai = [];
                        this.datatahunselesai = Response.data.content.data;
                        this.datatahunselesai.forEach((item) => {
                            this.tahunselesai.push({
                                label: item.tahun,
                                code: this.datatahunselesai.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });


                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedtahunselesai = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.tahunselesai.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedtahunselesai = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.tahunselesai.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationMasyarakat-Master?random=" + random + "&project_id=" + this.project_id + "&kategori=" + this.selectedkategori).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datakategori = [];
                        this.kategori = [];
                        this.datakategori = Response.data.content.data;

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.datakategori.forEach((item) => {
                                this.kategori.push({
                                    label: item.kategoriMasalahNm,
                                    code: this.datakategori.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedkategori = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.kategori.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.datakategori.forEach((item) => {
                                this.kategori.push({
                                    label: item.kategoriMasalahNm_eng,
                                    code: this.datakategori.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedkategori = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.kategori.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }



                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationMasyarakat-Media?random=" + random + "&project_id=" + this.project_id + "&media=" + this.selectedmedia).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamedia = [];
                        this.media = [];
                        this.datamedia = Response.data.content.data;
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.datamedia.forEach((item) => {
                                this.media.push({
                                    label: item.nama,
                                    code: this.datamedia.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedmedia = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.media.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.datamedia.forEach((item) => {
                                this.media.push({
                                    label: item.nama_eng,
                                    code: this.datamedia.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedmedia = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.media.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationMasyarakat-Status?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datastatus = [];
                        this.status = [];
                        this.datastatus = Response.data.content.data;

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.datastatus.forEach((item) => {
                                this.status.push({
                                    label: item.nama,
                                    code: this.datastatus.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedstatus = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.status.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.datastatus.forEach((item) => {
                                this.status.push({
                                    label: item.nama_eng,
                                    code: this.datastatus.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedstatus = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.status.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        async aduanAct(id) {
            const data = {
                project_id: this.project_id,
                jenis: id,
                lokasi: this.selectedlokasi,
                tahunmulai: this.selectedtahunmulai,
                tahunselesai: this.selectedtahunselesai,
                media: this.selectedmedia,
                status: this.selectedstatus,
            };

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPI.post("parastapainnovationMasyarakat-daftar", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        //document.getElementById("nama").focus();
                        return false;

                    }
                    else {
                        //alert('berhasil');
                        this.master = [];
                        this.master = Response.data.content.data;
                        $('#costumModalresume').modal('show');

                        return false;
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });

                    return false;
                }
            )
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationMasyarakat-Master?random=" + random + "&project_id=" + this.project_id + "&kategori=" + this.selectedkategori).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datakategori2 = [];
                        this.kategori2 = [];
                        this.datakategori2 = Response.data.content.data;

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.datakategori2.forEach((item) => {
                                this.kategori2.push({
                                    label: item.kategori2MasalahNm,
                                    code: this.datakategori2.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedkategori2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.kategori2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.datakategori2.forEach((item) => {
                                this.kategori2.push({
                                    label: item.kategori2MasalahNm_eng,
                                    code: this.datakategori2.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedkategori2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.kategori2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI.get("parastapainnovationMasyarakat-Media?random=" + random + "&project_id=" + this.project_id + "&media=" + this.selectedmedia).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamedia2 = [];
                        this.media2 = [];
                        this.datamedia2 = Response.data.content.data;

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.datamedia2.forEach((item) => {
                                this.media2.push({
                                    label: item.nama,
                                    code: this.datamedia2.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedmedia2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.media2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.datamedia2.forEach((item) => {
                                this.media2.push({
                                    label: item.nama_eng,
                                    code: this.datamedia2.indexOf(item) + 1,
                                    tag: item.id,
                                });
                            });
                            this.defaultSelectedmedia2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.media2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI.get("parastapainnovationMasyarakat-GetData?random=" + random + "&project_id=" + this.project_id + "&lokasi=" + this.selectedlokasi + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&media=" + this.selectedmedia + "&status=" + this.selectedstatus + "&kategori=" + this.selectedkategori).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    this.colspan = Response.data.jumlahproses + 1;
                    //alert(this.colspan);
                    this.datatahun = Response.data.tahun;
                    this.dataproses = Response.data.proses;
                    this.dataproses_eng = Response.data.proses_eng;
                    //alert(this.datatahun);
                    this.datamaster = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.colspan = 0;
                        this.datatahun = [];
                        this.dataproses = [];
                        this.dataproses_eng = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.colspan = 0;
                this.datatahun = [];
                this.dataproses = [];
                this.dataproses_eng = [];
                this.halamanloading = false;
            });


            await mainAPI.get("parastapainnovationDaftarAduanMasyarakat-GetData?random=" + random + "&project_id=" + this.project_id + "&lokasi=" + this.selectedlokasi + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&media=" + this.selectedmedia + "&status=" + this.selectedstatus + "&kategori=" + this.selectedkategori).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datatahun);
                    this.dataaduan1 = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataaduan1 = Response.data.content.data;
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.dataaduan1 = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.dataaduan1 = [];
                this.halamanloading = false;
            });


            await mainAPI.get("parastapainnovationResumeAduanMasyarakat-GetResume?random=" + random + "&project_id=" + this.project_id + "&lokasi=" + this.selectedlokasi + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&media=" + this.selectedmedia + "&status=" + this.selectedstatus + "&kategori=" + this.selectedkategori).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datatahun);
                    this.dataaduan2 = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.seriesbarjenis = [];
                        this.seriesbarmedia = [];
                        this.seriespiekategori = [];
                        this.seriespiemedia = [];
                        this.colspanmedia = 0;
                        this.colspanjenis = 0;
                        this.dataaduan2 = [];
                        this.colspanmedia = Response.data.colspanmedia;
                        this.colspanjenis = Response.data.colspanjenis;
                        this.dataaduan2 = Response.data.content.data;
                        var datapertahun = [];
                        datapertahun = Response.data.content.tahun;

                        var dataperjenis = [];
                        dataperjenis = Response.data.content.jenis;
                        //alert(JSON.stringify(dataperjenis));

                        var datapermedia = [];
                        datapermedia = Response.data.content.media;
                        //alert(JSON.stringify(datapertahun));
                        var namakota = [];
                        var jumlahregister = [];
                        var jumlahselesai = [];

                        var namatahun = [];
                        var jumlahregistertahun = [];
                        var jumlahselesaitahun = [];

                        var namajenis = [];
                        var jumlahregisterjenis = [];
                        var jumlahselesaijenis = [];

                        var namamedia = [];
                        var jumlahregistermedia = [];
                        var jumlahselesaimedia = [];

                        var totalregister = this.dataaduan2.reduce((a, { jumlahaduanbelumselesai: e }) => a + e, 0);
                        var totalselesai = this.dataaduan2.reduce((a, { jumlahaduanselesai: e }) => a + e, 0);
                        //alert(totalregister);

                        for (let i = 0; i < this.dataaduan2.length; i++) {
                            namakota.push(this.dataaduan2[i].nama);
                            jumlahregister.push(this.dataaduan2[i].jumlahaduan);
                            jumlahselesai.push(this.dataaduan2[i].jumlahaduanselesai);
                        }

                        for (let i = 0; i < datapertahun.length; i++) {
                            namatahun.push(datapertahun[i].tahun);
                            jumlahregistertahun.push(datapertahun[i].jumlahaduan);
                            jumlahselesaitahun.push(datapertahun[i].jumlahaduanselesai);
                        }

                        for (let i = 0; i < dataperjenis.length; i++) {
                            this.seriespiekategori.push(dataperjenis[i].jumlahaduan);
                            if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                                namajenis.push(dataperjenis[i].nama);
                            }
                            else {
                                namajenis.push(dataperjenis[i].nama_eng);
                            }
                            jumlahregisterjenis.push(dataperjenis[i].jumlahaduan);
                            jumlahselesaijenis.push(dataperjenis[i].jumlahaduanselesai);
                        }

                        for (let i = 0; i < datapermedia.length; i++) {
                            this.seriespiemedia.push(datapermedia[i].jumlahaduan);
                            if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                                namamedia.push(datapermedia[i].nama);
                            }
                            else {
                                namamedia.push(datapermedia[i].nama_eng);
                            }

                            jumlahregistermedia.push(datapermedia[i].jumlahaduan);
                            jumlahselesaimedia.push(datapermedia[i].jumlahaduanselesai);
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionsbar1 = {
                                title: {
                                    text: 'Jumlah Total Aduan Per Lokasi',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namakota,
                                    title: {
                                        text: 'Lokasi'
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: 'Jumlah Aduan'
                                    }
                                },
                            };
                            this.seriesbar1 = [{
                                name: 'Register',
                                data: jumlahregister
                            }, {
                                name: 'Selesai',
                                data: jumlahselesai
                            }];
                        }
                        else {
                            this.chartOptionsbar1 = {
                                title: {
                                    text: 'Total Number of Complaints Per Location',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namakota,
                                    title: {
                                        text: 'Location'
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: 'Number of Complaints'
                                    }
                                },
                            };
                            this.seriesbar1 = [{
                                name: 'Register',
                                data: jumlahregister
                            }, {
                                name: 'Finished',
                                data: jumlahselesai
                            }];
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionsbartahun = {
                                title: {
                                    text: 'Jumlah Total Aduan Per Tahun',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namatahun,
                                    title: {
                                        text: 'Tahun'
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: 'Jumlah Aduan'
                                    }
                                },
                            };
                            this.seriesbartahun = [{
                                name: 'Register',
                                data: jumlahregistertahun
                            }, {
                                name: 'Selesai',
                                data: jumlahselesaitahun
                            }];
                        }
                        else {
                            this.chartOptionsbartahun = {
                                title: {
                                    text: 'Total Number of Complaints Per Year',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namatahun,
                                    title: {
                                        text: 'Years'
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: 'Number of Complaints'
                                    }
                                },
                            };
                            this.seriesbartahun = [{
                                name: 'Register',
                                data: jumlahregistertahun
                            }, {
                                name: 'Finished',
                                data: jumlahselesaitahun
                            }];
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionsbarjenis = {
                                title: {
                                    text: 'Jumlah Total Aduan Per Kategori',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namajenis,
                                    title: {
                                        text: 'Kategori'
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: 'Jumlah Aduan'
                                    }
                                },
                            };
                            this.seriesbarjenis = [{
                                name: 'Register',
                                data: jumlahregisterjenis
                            }, {
                                name: 'Selesai',
                                data: jumlahselesaijenis
                            }];

                        }
                        else {
                            this.chartOptionsbarjenis = {
                                title: {
                                    text: 'Total Number of Complaints Per Category',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namajenis,
                                    title: {
                                        text: 'Category'
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: 'Number of Complaints'
                                    }
                                },
                            };
                            this.seriesbarjenis = [{
                                name: 'Register',
                                data: jumlahregisterjenis
                            }, {
                                name: 'Finished',
                                data: jumlahselesaijenis
                            }];

                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionsbarmedia = {
                                title: {
                                    text: 'Jumlah Total Aduan Per Saluran Pengaduan',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namamedia,
                                    title: {
                                        text: 'Saluran Aduan'
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: 'Jumlah Aduan'
                                    }
                                },
                            };
                            this.seriesbarmedia = [{
                                name: 'Register',
                                data: jumlahregistermedia
                            }, {
                                name: 'Selesai',
                                data: jumlahselesaimedia
                            }];
                        }
                        else {
                            this.chartOptionsbarmedia = {
                                title: {
                                    text: 'Total Number of Complaints Per Complaint Channel',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namamedia,
                                    title: {
                                        text: 'Complaint Channel'
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: 'Number of Complaints'
                                    }
                                },
                            };
                            this.seriesbarmedia = [{
                                name: 'Register',
                                data: jumlahregistermedia
                            }, {
                                name: 'Finished',
                                data: jumlahselesaimedia
                            }];
                        }

                        this.seriespie1 = [totalselesai, totalregister];

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionspie1 = {
                                title: {
                                    text: 'Jumlah Total Aduan',
                                    align: 'center'
                                },
                                labels: ['Selesai', 'Belum Selesai'],
                            };
                            this.chartOptionspiekategori = {
                                title: {
                                    text: 'Jumlah Kategori Aduan',
                                    align: 'center'
                                },
                                labels: namajenis,
                            };
                        }
                        else {
                            this.chartOptionspie1 = {
                                title: {
                                    text: 'Total Number of Complaints',
                                    align: 'center'
                                },
                                labels: ['Finished', 'Not finished yet'],
                            };
                            this.chartOptionspiekategori = {
                                title: {
                                    text: 'Number of Complaint Categories',
                                    align: 'center'
                                },
                                labels: namajenis,
                            };
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionspiemedia = {
                                title: {
                                    text: 'Jumlah Saluran Pengaduan',
                                    align: 'center'
                                },
                                labels: namamedia,
                            };
                        }
                        else {
                            this.chartOptionspiemedia = {
                                title: {
                                    text: 'Number of Complaint Channels',
                                    align: 'center'
                                },
                                labels: namamedia,
                            };
                        }

                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.colspanmedia = 0;
                        this.colspanjenis = 0;
                        this.dataaduan2 = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.colspanmedia = 0;
                this.colspanjenis = 0;
                this.dataaduan2 = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildatareff();
        this.ambildata();
    },
}
</script>

<style></style>